module.exports = __webpack_public_path__ + "img/ir.ca2a056b.svg";